import React from 'react';
import { Trophy, Users, MapPin, User } from 'lucide-react';
const MatchHeader = () => {
  const matchData = {
    league: 'NBA',
    season: '2023-2024',
    date: 'March 15, 2024',
    status: 'Final',
    arena: 'Madison Square Garden',
    referee: 'Marc Davis',
    homeTeam: {
      name: 'New York Knicks',
      logo: 'https://cdn.nba.com/logos/nba/1610612752/global/L/logo.svg',
      score: 112,
      record: '35-24',
      topPlayer: {
        name: 'Jalen Brunson',
        stats: '34 PTS, 9 AST, 5 REB'
      },
      quarterScores: [28, 31, 24, 29]
    },
    awayTeam: {
      name: 'Los Angeles Lakers',
      logo: 'https://cdn.nba.com/logos/nba/1610612747/global/L/logo.svg',
      score: 108,
      record: '31-28',
      topPlayer: {
        name: 'LeBron James',
        stats: '28 PTS, 12 AST, 9 REB'
      },
      quarterScores: [24, 28, 30, 26]
    }
  };
  return <div className="bg-white shadow-md rounded-lg overflow-hidden" data-id="element-265" data-mp="y026kvb4e4d7">
      <div className="p-4 md:p-6" data-id="element-266" data-mp="y2wq8kmb7l5k">
        <div className="grid grid-cols-3 gap-4" data-id="element-267" data-mp="2veosz2581m9n">
          <div className="col-span-1" data-id="element-268" data-mp="2vcvkrieymtzj">
            <div className="border-2 border-blue-500 rounded-lg p-3 h-full" data-id="element-269" data-mp="30ekwz1dx5dp7">
              <div className="flex flex-col items-center text-center" data-id="element-270" data-mp="2lgslqlfenbgt">
                <img src={matchData.awayTeam.logo} alt={matchData.awayTeam.name} className="w-16 h-16 md:w-20 md:h-20 object-contain" data-id="element-271" data-mp="2lgivcwqg72al" />
                <h2 className="text-lg md:text-2xl font-bold mt-2" data-id="element-272" data-mp="2cmdurlliichv">
                  {matchData.awayTeam.name}
                </h2>
                <div className="text-sm text-gray-500 mb-3" data-id="element-273" data-mp="22qj8mgi2xzac">
                  {matchData.awayTeam.record}
                </div>
                <div className="mt-auto pt-3 border-t border-gray-100 w-full" data-id="element-274" data-mp="27qfbudiydmou">
                  <div className="flex flex-col items-center text-sm text-gray-600" data-id="element-275" data-mp="1tp2zsd6wy588">
                    <Trophy className="w-4 h-4 mb-1" data-id="element-276" data-mp="1xqy7q0jcnguz" />
                    <div className="font-medium text-xs md:text-sm" data-id="element-277" data-mp="1xqeq6kxm2uhh">
                      Top Performer
                    </div>
                    <div className="font-medium" data-id="element-278" data-mp="3vn50ht99s8jf">
                      {matchData.awayTeam.topPlayer.name}
                    </div>
                    <div className="text-xs" data-id="element-279" data-mp="3qna6vhy414uo">
                      {matchData.awayTeam.topPlayer.stats}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1" data-id="element-280" data-mp="n6tfxvm1bejw">
            <div className="h-full flex flex-col justify-between" data-id="element-281" data-mp="i88niid0xz60">
              <div className="text-center" data-id="element-282" data-mp="i91m2w1txid2">
                <div className="flex items-center justify-center gap-4 mb-4" data-id="element-283" data-mp="d8mc8egraszu">
                  <div className="text-4xl md:text-6xl font-bold text-blue-600" data-id="element-284" data-mp="97kbft76y8vr">
                    {matchData.awayTeam.score}
                  </div>
                  <div className="flex flex-col items-center mx-2" data-id="element-285" data-mp="2y05yr43q0aeo">
                    <div className="text-sm md:text-base font-semibold text-gray-800" data-id="element-286" data-mp="2tx9n5xcllek8">
                      {matchData.status}
                    </div>
                    <div className="px-3 py-1 bg-gray-100 rounded-full text-xs text-gray-600" data-id="element-287" data-mp="19hl9lyufnty4">
                      Final
                    </div>
                  </div>
                  <div className="text-4xl md:text-6xl font-bold text-red-600" data-id="element-288" data-mp="1ifn9gb2fkgjt">
                    {matchData.homeTeam.score}
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-2 md:p-3" data-id="element-289" data-mp="1s6rp7czxk5fp">
                  <table className="w-full text-xs md:text-sm" data-id="element-290" data-mp="1s8kuanuwahll">
                    <thead data-id="element-291" data-mp="1x3rtpjh4t04p">
                      <tr className="text-gray-600" data-id="element-292" data-mp="1x75x8v1j7fdq">
                        <th className="font-medium p-1 text-left" data-id="element-293" data-mp="217zn3tyjb499">Team</th>
                        <th className="font-medium p-1" data-id="element-294" data-mp="266j89s5b0c0k">Q1</th>
                        <th className="font-medium p-1" data-id="element-295" data-mp="263wzxqal9sha">Q2</th>
                        <th className="font-medium p-1" data-id="element-296" data-mp="6tykqz3rzz4f">Q3</th>
                        <th className="font-medium p-1" data-id="element-297" data-mp="brqdtwg5pra7">Q4</th>
                      </tr>
                    </thead>
                    <tbody className="text-center" data-id="element-298" data-mp="3cmens2cwexyc">
                      <tr className="text-blue-600" data-id="element-299" data-mp="3cpakjnd0fgl7">
                        <td className="p-1 text-left font-medium" data-id="element-300" data-mp="37oweubyvsiqc">LAL</td>
                        {matchData.awayTeam.quarterScores.map((score, i) => <td key={i} className="p-1" data-id="element-301" data-mp="3mj15wjdubawo" data-mpi={i}>
                            {score}
                          </td>)}
                      </tr>
                      <tr className="text-red-600" data-id="element-302" data-mp="2tx83wc0dc0ay">
                        <td className="p-1 text-left font-medium" data-id="element-303" data-mp="2oy56ndqmqydj">NYK</td>
                        {matchData.homeTeam.quarterScores.map((score, i) => <td key={i} className="p-1" data-id="element-304" data-mp="33nudnplelwlq" data-mpi={i}>
                            {score}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="mt-4 text-sm text-gray-600 flex justify-center items-center gap-2" data-id="element-305" data-mp="267nhtk8x4mxg">
                  <span className="font-medium" data-id="element-306" data-mp="lol50mddz984">{matchData.league}</span>
                  <span className="text-gray-400" data-id="element-307" data-mp="qftax8ficcgj">•</span>
                  <span data-id="element-308" data-mp="qhe6909nbzfg">{matchData.season}</span>
                  <span className="text-gray-400" data-id="element-309" data-mp="br6xjc9fxury">•</span>
                  <span data-id="element-310" data-mp="bsqez66u2bvb">{matchData.date}</span>
                </div>
              </div>
              <div className="flex justify-center gap-4 mt-3 text-xs md:text-sm text-gray-600" data-id="element-311" data-mp="gqru5g151r1i">
                <div className="flex items-center" data-id="element-312" data-mp="14gvzpsxw00v5">
                  <MapPin className="w-4 h-4 mr-1" data-id="element-313" data-mp="19efdkrqoabmk" />
                  {matchData.arena}
                </div>
                <div className="flex items-center" data-id="element-314" data-mp="vffpbl72nyqx">
                  <User className="w-4 h-4 mr-1" data-id="element-315" data-mp="vemrxau06llg" />
                  {matchData.referee}
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1" data-id="element-316" data-mp="3g4vksth8kbmw">
            <div className="border-2 border-red-500 rounded-lg p-3 h-full" data-id="element-317" data-mp="3g3u2c3xw4mv5">
              <div className="flex flex-col items-center text-center" data-id="element-318" data-mp="3k7i6sdr872c6">
                <img src={matchData.homeTeam.logo} alt={matchData.homeTeam.name} className="w-16 h-16 md:w-20 md:h-20 object-contain" data-id="element-319" data-mp="1qojd40fjpu2c" />
                <h2 className="text-lg md:text-2xl font-bold mt-2" data-id="element-320" data-mp="1gxev0rukpt3a">
                  {matchData.homeTeam.name}
                </h2>
                <div className="text-sm text-gray-500 mb-3" data-id="element-321" data-mp="1bytuerbet7eb">
                  {matchData.homeTeam.record}
                </div>
                <div className="mt-auto pt-3 border-t border-gray-100 w-full" data-id="element-322" data-mp="12yf75mevxi86">
                  <div className="flex flex-col items-center text-sm text-gray-600" data-id="element-323" data-mp="130i7p0dnytr5">
                    <Trophy className="w-4 h-4 mb-1" data-id="element-324" data-mp="xzuf4a9se4ut" />
                    <div className="font-medium text-xs md:text-sm" data-id="element-325" data-mp="t0ra2ptt3ymu">
                      Top Performer
                    </div>
                    <div className="font-medium" data-id="element-326" data-mp="2sc29nmi74jq2">
                      {matchData.homeTeam.topPlayer.name}
                    </div>
                    <div className="text-xs" data-id="element-327" data-mp="2ncftp5azgpdk">
                      {matchData.homeTeam.topPlayer.stats}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default MatchHeader;